import React from "react";
import {Page} from "../../../components/page/page";
import styles from "./romantic-life.module.css";
import Image from "../../../images/couple3.png";
import {useSelector} from "react-redux";

const RomanticLifePage = () => {
    const state = useSelector((store) => store.future);

    const buttonStyles = {
        backgroundColor: "rgb(255, 209, 40)",
        border: "1px solid rgb(255, 209, 40)",
        color: "#000000",
        fontSize: '18px',
        boxShadow: 'none',
        borderRadius: '150px',
        position: "absolute",
        bottom: "30px",
        width: "90%",
        zIndex: "5",
        maxWidth: "500px",
        boxSizing: "border-box",
        left: "20px",
        right: "20px"
    };

    const headerStyles = {
        backgroundColor: "transparent",
    }

    return (
        <div className={styles.container_page}>
            <Page title={[<span>{state.gender} {state.zodiacSign}</span>, " often overthink their romantic life"]}
                  nextPageLink="../additional-goals" buttonStyles={buttonStyles} currentStep="15" headerStyles={headerStyles} isWhiteLogo={true} isWhiteButton={true}>
                <p className={styles.text}>
                    The good thing is, you <span>deeply care about others and value close connections</span>, which
                    often leads to a happy romantic life.
                </p>
                <img className={styles.couple_image} src={Image} alt=""/>
            </Page>
        </div>
    );
}

export {RomanticLifePage};